import React from 'react';
import NumberChooser from './NumberChooser.js';
import Field from './Field.js';
import Players from './Players.js';
import Utils from './Utils.js';
import html2canvas from 'html2canvas';
import ReactDOM from 'react-dom';
import firebase from './Firebase.js';
import {Radar} from 'react-chartjs-2';


class DreamTeam extends React.Component
{
	
	constructor(props)
	{
		super(props);
		
		this.setPlayerNb = this.setPlayerNb.bind(this);
		this.setPlayerNames = this.setPlayerNames.bind(this);
		this.onPlayerNameChange = this.onPlayerNameChange.bind(this);
		this.onPlayerSwitch = this.onPlayerSwitch.bind(this);
		this.save = this.save.bind(this);
		this.canvas ="";

		this.data = {
			labels: ['Général', 'Tenue Ballon', 'Physique', 'Gardien', 'Défense'],
			datasets: [
				{
					label: 'Équipe 1',
					data: [],
					backgroundColor: 'rgba(255, 0, 0, 0.2)',
					borderColor: 'rgba(255, 0, 0, 0.6)'
				},
				{
					label: 'Équipe 2',
					data: [],
					backgroundColor: 'rgba(0, 0, 255, 0.2)',
					borderColor: 'rgba(0, 0, 255, 0.6)'
				}
			]
		}

		var options = {
			legend:{
				position: "left"
			},
			scale: {
				ticks: {
					beginAtZero: true,
					min:0, 
					max:5,
					stepSize: 1,
					display: false
				}
			}
		};

		this.field = React.createRef();
		this.baliseA = React.createRef();

		var playerNames = new Array(10);
		for (var i=0;i<playerNames.length; i++)
			playerNames[i] = "";
		
		this.state = {
			playerNb: 10,
			playerNames : playerNames,
			playerList : [],
			data: this.data,
			options: options
		};
		
		this.image_url = require("./bg.png");
	}

	componentDidMount()
	{
		const playersRef = firebase.database().ref('players');
		let tab = [];

		playersRef.on('value', (snapshot) =>
		{
			let players = snapshot.val();

			for (let player in players)
			{
				var pl = {
					name: player,
					general: players[player].general,
					tenueballon : players[player].tenueballon,
					physique : players[player].physique,
					gardien : players[player].gardien,
					replidef : players[player].replidef,
					isAvailable: true
				};
				tab.push(pl);
			}

			this.setState({playerList : tab});
		});
	}
	
	setPlayerNb(playerNb)
	{

		if (playerNb == 8)
		{
			let tabPlayers = [];

			for (let i=0; i<playerNb; i++)
			{
				tabPlayers[i] = this.state.playerNames[i];
			}

			this.setPlayerNames(tabPlayers);
		}
		

		this.setState({
			playerNb: playerNb
		});
		
		this.majDiagramme(this.state.playerNames, playerNb);
	}
	
	setPlayerNames(playerNames)
	{
		this.setState({playerNames: playerNames});	

		this.majDiagramme(playerNames, this.state.playerNb);
	}

	majDiagramme(playerNames, playerNb)
	{
		let team1Ratings = {
			general: 0,
			tenueballon : 0,
			physique : 0,
			gardien : 0,
			replidef : 0
		};

		let team2Ratings = {
			general: 0,
			tenueballon : 0,
			physique : 0,
			gardien : 0,
			replidef : 0
		};

		let tabPlayerList = [];
		for (let i=0;i<this.state.playerList.length; i++)
		{
			tabPlayerList[i] = this.state.playerList[i];
			tabPlayerList[i].isAvailable = true;
		}

		var nbPlayersByTeam = playerNb/2;
		var allPlayersSet1 = true;
		var allPlayersSet2 = true;

		//Team 1
		for (let i=0;i<nbPlayersByTeam; i++)
		{
			if (playerNames[i] !== "")
			{
				let playerIndex = this.getPlayerIndexByName(playerNames[i]);
				let player = this.state.playerList[playerIndex];
				if (player)
				{
					team1Ratings.general += player.general;
					team1Ratings.tenueballon += player.tenueballon;
					team1Ratings.physique += player.physique;
					team1Ratings.gardien += player.gardien;
					team1Ratings.replidef += player.replidef;

					tabPlayerList[playerIndex].isAvailable = false;
				}
				else
				{
					team1Ratings.general += 3;
					team1Ratings.tenueballon += 3;
					team1Ratings.physique += 3;
					team1Ratings.gardien += 3;
					team1Ratings.replidef += 3;
				}
			}
			else
			{
				allPlayersSet1 = false;
			}
		}

		for (let i=nbPlayersByTeam;i<nbPlayersByTeam*2; i++)
		{
			if (playerNames[i] !== "")
			{
				let playerIndex = this.getPlayerIndexByName(playerNames[i]);
				let player = this.state.playerList[playerIndex];
				if (player)
				{
					team2Ratings.general += player.general;
					team2Ratings.tenueballon += player.tenueballon;
					team2Ratings.physique += player.physique;
					team2Ratings.gardien += player.gardien;
					team2Ratings.replidef += player.replidef;
					tabPlayerList[playerIndex].isAvailable = false;
				}
				else
				{
					team2Ratings.general += 3;
					team2Ratings.tenueballon += 3;
					team2Ratings.physique += 3;
					team2Ratings.gardien += 3;
					team2Ratings.replidef += 3;
				}
			}
			else
			{
				allPlayersSet2 = false;
			}
		}

		for (let att in team1Ratings)
		{
			team1Ratings[att] /= nbPlayersByTeam;
			team2Ratings[att] /= nbPlayersByTeam;
		}

		if (allPlayersSet1 === true)
		{
			this.data.datasets[0].data = [team1Ratings.general, team1Ratings.tenueballon, team1Ratings.physique, team1Ratings.gardien, team1Ratings.replidef];
		}
		else
		{
			this.data.datasets[0].data = [];
		}

		if (allPlayersSet2 === true)
		{
			this.data.datasets[1].data = [team2Ratings.general, team2Ratings.tenueballon, team2Ratings.physique, team2Ratings.gardien, team2Ratings.replidef];
		}
		else
		{
			this.data.datasets[1].data = [];
		}

		this.setState(
			{
				data: this.data,
				playerList: tabPlayerList
			}
		);
	}

	getPlayerIndexByName(playerName)
	{
		var playerIndex = -1;

		for (var i=0;i<this.state.playerList.length; i++)
		{
			if (this.state.playerList[i].name === playerName)
				playerIndex = i;
		}

		return playerIndex;
	}
	
	onPlayerNameChange (num, name)
	{
		var tab = [];
		for (var i=0;i<this.state.playerNames.length; i++)
			tab[i] = this.state.playerNames[i];
		tab[num-1] = name;
		this.setPlayerNames(tab);
	}

	onPlayerSwitch(playerNum1, playerNum2)
	{
		var tab = [];
		for (var i=0;i<this.state.playerNames.length; i++)
			tab[i] = this.state.playerNames[i];

		var player1Name = tab[playerNum1-1];
		tab[playerNum1-1] = tab[playerNum2-1];
		tab[playerNum2-1] = player1Name;

		this.setPlayerNames(tab);
	}

	save()
	{
		var field1 = ReactDOM.findDOMNode(this.field.current);
		html2canvas(field1).then(canvas => {
			//document.body.appendChild(canvas)

			var today = new Date();
			var dd = today.getDate();

			var mm = today.getMonth()+1; 
			var yyyy = today.getFullYear();
			if(dd<10) 
			{
				dd='0'+dd;
			} 

			if(mm<10) 
			{
				mm='0'+mm;
			} 

			this.canvas = canvas;
			this.baliseA.current.href = canvas.toDataURL("image/png");
			this.baliseA.current.download = yyyy+""+mm+""+dd+'_dreamteam.png';
			this.baliseA.current.click();
		});
	}

	keepBestMatches(matches, score, team1, team2) {
    
		const maxNbMatches = 10;
		
		/* Keep the X best matches */
		if (matches.length < maxNbMatches) {
			matches.push({team1: team1, team2: team2, score: score})
		}
		else {
			/* Find the index of the worst match in array (for score, the lower, the better) */
			var worstIndex = 0;
			var worstScore = 0;
			for (var i in matches) {
				if(matches[i]['score'] > worstScore) {
					worstIndex = i;
					worstScore = matches[i]['score'];
				}
			}
			
			if (worstScore > score) {
				matches[worstIndex] = {team1: team1, team2: team2, score: score}
			}
		}
	}
	
	genTeam(players, stats) {
		const players8Combinations = ["01234567", "01243567", "01253467", "01263457", "01273456", "01342567", "01352467", "01362457", "01372456", "01452367", "01462357", "01472356", "01562347", "01572346", "01672345", "02341567", "02351467", "02361457", "02371456", "02451367", "02461357", "02471356", "02561347", "02571346", "02671345", "03451267", "03461257", "03471256", "03561247", "03571246", "03671245", "04561237", "04571236", "04671235", "05671234"];
		const players10Combinations = ["0123456789", "0123546789", "0123645789", "0123745689", "0123845679", "0123945678", "0124536789", "0124635789", "0124735689", "0124835679", "0124935678", "0125634789", "0125734689", "0125834679", "0125934678", "0126734589", "0126834579", "0126934578", "0127834569", "0127934568", "0128934567", "0134526789", "0134625789", "0134725689", "0134825679", "0134925678", "0135624789", "0135724689", "0135824679", "0135924678", "0136724589", "0136824579", "0136924578", "0137824569", "0137924568", "0138924567", "0145623789", "0145723689", "0145823679", "0145923678", "0146723589", "0146823579", "0146923578", "0147823569", "0147923568", "0148923567", "0156723489", "0156823479", "0156923478", "0157823469", "0157923468", "0158923467", "0167823459", "0167923458", "0168923457", "0178923456", "0234516789", "0234615789", "0234715689", "0234815679", "0234915678", "0235614789", "0235714689", "0235814679", "0235914678", "0236714589", "0236814579", "0236914578", "0237814569", "0237914568", "0238914567", "0245613789", "0245713689", "0245813679", "0245913678", "0246713589", "0246813579", "0246913578", "0247813569", "0247913568", "0248913567", "0256713489", "0256813479", "0256913478", "0257813469", "0257913468", "0258913467", "0267813459", "0267913458", "0268913457", "0278913456", "0345612789", "0345712689", "0345812679", "0345912678", "0346712589", "0346812579", "0346912578", "0347812569", "0347912568", "0348912567", "0356712489", "0356812479", "0356912478", "0357812469", "0357912468", "0358912467", "0367812459", "0367912458", "0368912457", "0378912456", "0456712389", "0456812379", "0456912378", "0457812369", "0457912368", "0458912367", "0467812359", "0467912358", "0468912357", "0478912356", "0567812349", "0567912348", "0568912347", "0578912346", "0678912345"];

		const weightGardien = 0.5;
		const weightGeneral = 2;
		const weightPhysique = 1;
		const weightReplidef = 1;
		const weightTenueballon = 0.7;
		
		var combinations = []
		if (players.length == 8)
			combinations = players8Combinations;
		else if (players.length == 10)
			combinations = players10Combinations;
		else
			return {team1: [], team2: [], score: 0.0}
		
		/* Go through all combinations and compute the average of each team.
		Then the absolute difference between the two teams is computed.
		The lowest, the better. Only keep the lowest */
		var matches = [];
		for (var i in combinations) {
			var team1Score = {gardien: 0, general: 0, physique: 0, replidef: 0, tenueballon: 0};
			var team1 = [];
			var team2Score = {gardien: 0, general: 0, physique: 0, replidef: 0, tenueballon: 0};
			var team2 = [];
			for (var j in combinations[i]) {
				if(j < combinations[i].length/2) {
					team1Score['gardien'] += stats[players[combinations[i][j]]]['gardien']
					team1Score['general'] += stats[players[combinations[i][j]]]['general']
					team1Score['physique'] += stats[players[combinations[i][j]]]['physique']
					team1Score['replidef'] += stats[players[combinations[i][j]]]['replidef']
					team1Score['tenueballon'] += stats[players[combinations[i][j]]]['tenueballon']
					team1.push(players[combinations[i][j]])
				}
				else {
					team2Score['gardien'] += stats[players[combinations[i][j]]]['gardien']
					team2Score['general'] += stats[players[combinations[i][j]]]['general']
					team2Score['physique'] += stats[players[combinations[i][j]]]['physique']
					team2Score['replidef'] += stats[players[combinations[i][j]]]['replidef']
					team2Score['tenueballon'] += stats[players[combinations[i][j]]]['tenueballon']
					team2.push(players[combinations[i][j]])
				}
			}
			
			var matchScore = weightGardien*Math.abs(team1Score['gardien']-team2Score['gardien'])+weightGeneral*Math.abs(team1Score['general']-team2Score['general'])+weightPhysique*Math.abs(team1Score['physique']-team2Score['physique'])+weightReplidef*Math.abs(team1Score['replidef']-team2Score['replidef'])+weightTenueballon*Math.abs(team1Score['tenueballon']-team2Score['tenueballon'])
			matchScore = matchScore/(combinations[i].length/2);
			
			this.keepBestMatches(matches, matchScore, team1, team2);
		}
		
		const match = matches[Math.floor(Math.random() * matches.length)];
		
		return match;
	}

	genererEquipes()
	{
		var stats = {};
		for (var i=0;i<this.state.playerNames.length; i++)
		{
			let playerIndex = this.getPlayerIndexByName(this.state.playerNames[i]);
			let player = this.state.playerList[playerIndex];

			var plStats = {
				'gardien': player.gardien,
				'general': player.general,
				'physique': player.physique,
				'replidef': player.replidef,
				'tenueballon' : player.tenueballon
			};

			stats[this.state.playerNames[i]] = plStats;
		}
		var match = this.genTeam(this.state.playerNames, stats);
		
		var newPlNames = [];
		for (let i in match.team1)
		{
			newPlNames.push(match.team1[i]);
		}

		for (let i in match.team2)
		{
			newPlNames.push(match.team2[i]);
		}

		this.setPlayerNames(newPlNames);
	}
	
	render() {
		return (
			<div className="dreamteam">
				
				
				<div className="leftColumn">
					<NumberChooser onChangeNumber={this.setPlayerNb}/>
					<Players nbPlayers={this.state.playerNb} playerNames={this.state.playerNames} onPlayerNameChange={this.onPlayerNameChange} playerList={this.state.playerList}/>
				</div>
				<div className="footer">
					<button className="bouton" onClick={this.genererEquipes.bind(this)}>Générer</button>
					<button className="bouton" onClick={this.save.bind(this)}>Sauvegarder</button>
				</div>
				<div ref={this.field} className="rightColumn">
					<Field id="field" nbPlayers={this.state.playerNb} playerNames={this.state.playerNames} onPlayerSwitch={this.onPlayerSwitch} />
					<div className="diagramme">
						<Radar data={this.state.data} options={this.state.options} />
					</div>
				</div>
				<div>{this.canvas}</div>
				<a id="baliseA" ref={this.baliseA}></a>
			</div>
			
		);
	}
}

export default DreamTeam;
